import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">
            {t.faq.overline}
          </span>
          <h2 className="mt-4 font-outfit text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            {t.faq.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {t.faq.items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.03] px-6"
            >
              <AccordionTrigger className="text-left font-outfit text-base font-semibold text-white hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
